// --- Products
import { products } from './products/reducer';
// --- Clearance Memo Titles
import { titles } from './clearanceMemoTitles/reducer';
// --- Shared Sections
import { sharedSections } from './sharedSections/reducer';
// --- UI State Management
import spinner from './spinner/reducer';
import auth from './auth/reducer';
// --- User & Content Management
import { users } from './users/reducer';
import { contacts } from './contacts/reducer';
import { comments } from './comments/reducer';
import { tags } from './tags/reducer';
import { linkedProducts } from './linkedProducts/reducer';

// --- Exporting all reducers
export const clearanceMemoReducers = {
    products,
    linkedProducts,
    titles,
    sharedSections,
    contacts,
    spinner,
    auth,
    users,
    comments,
    tags,
};
